import script from "./EmployeeAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeAccount.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeAccount.vue?vue&type=style&index=0&id=ef4249de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef4249de"]])

export default __exports__